import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ShippingCostGuidePage from "../pages/article/shipping-cost-guide/page";
import IsSugargooLegitPage from "../pages/article/is-sugargoo-legit/page";
import CouponGuidePage from "../pages/article/coupon-guide/page";
import BeginnerGuidePage from "../pages/article/beginner-guide/page";
import BestFindsPage from "../pages/article/best-finds/page";
import WarehouseGuidePage from "../pages/article/warehouse-guide/page";
import VsAlternativesPage from "../pages/article/vs-alternatives/page";
import ShoppingTipsPage from "../pages/article/shopping-tips/page";
import SpreadsheetCategoriesPage from "../pages/article/spreadsheet-categories/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/sugargoo-shipping-cost-guide",
    element: <ShippingCostGuidePage />,
  },
  {
    path: "/is-sugargoo-legit",
    element: <IsSugargooLegitPage />,
  },
  {
    path: "/sugargoo-coupon-guide",
    element: <CouponGuidePage />,
  },
  {
    path: "/sugargoo-beginner-guide",
    element: <BeginnerGuidePage />,
  },
  {
    path: "/sugargoo-best-finds",
    element: <BestFindsPage />,
  },
  {
    path: "/sugargoo-warehouse-guide",
    element: <WarehouseGuidePage />,
  },
  {
    path: "/sugargoo-vs-alternatives",
    element: <VsAlternativesPage />,
  },
  {
    path: "/sugargoo-shopping-tips",
    element: <ShoppingTipsPage />,
  },
  {
    path: "/sugargoo-spreadsheet-categories",
    element: <SpreadsheetCategoriesPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;